import Button from 'components/Button'
import QuestionIcon from 'jobs/components/QuestionIcon'
import { JobProgressionStep } from 'jobs/progression/JobProgression'
import { observer } from 'mobx-react'
import React from 'react'
import {
  Card,
  CardContent,
  CardFooter,
  CardFooterItem,
  CardFooterSpacer,
} from '../MessageCard'
import JobProgressionMessageContentViewModel from './JobProgressionMessageContentViewModel'
import styles from './ProgressionMessageContent.sass'

export interface JobProgressionMessageContentProps {
  vm: JobProgressionMessageContentViewModel
}

export default observer(function JobProgressionMessageContent({
  vm,
}: JobProgressionMessageContentProps) {
  if (vm.progressionStep === null) {
    return null
  }

  if (vm.canAnswerDraftInReviewMessage) {
    return (
      <DraftInReviewMessageContent
        jobProgression={vm.progressionStep}
        onViewApproveDraft={vm.onViewApproveDraft}
        onViewRejectDraft={vm.onViewRejectDraft}
      />
    )
  }

  return <JobProgressionReadonlyMessageContent vm={vm} />
})

interface JobProgressionReadonlyProps {
  vm: JobProgressionMessageContentViewModel
}

const JobProgressionReadonlyMessageContent = observer(
  function JobProgressionReadonlyMessageContent({
    vm,
  }: JobProgressionReadonlyProps) {
    return (
      <div className={styles.root}>
        <Card>
          <CardContent
            title={vm.title}
            visual={<QuestionIcon size={30} type={'BOOL'} />}
          >
            {vm.description}
          </CardContent>
        </Card>
      </div>
    )
  },
)

interface DraftInReviewMessageContentProps {
  jobProgression?: JobProgressionStep
  onViewRejectDraft: () => void
  onViewApproveDraft: () => void
}

const DraftInReviewMessageContent = observer(
  function DraftInReviewMessageContent({
    jobProgression,
    onViewRejectDraft,
    onViewApproveDraft,
  }: DraftInReviewMessageContentProps) {
    return (
      <div className={styles.root}>
        <Card>
          <CardContent
            title="The return is now ready for review"
            visual={<QuestionIcon size={30} type={'BOOL'} />}
          >
            Do you approve the latest draft return?
          </CardContent>
          {!jobProgression?.response && (
            <CardFooter>
              <CardFooterSpacer />
              <CardFooterItem>
                <Button type="secondary" onClick={onViewRejectDraft}>
                  No
                </Button>
              </CardFooterItem>
              <CardFooterItem>
                <Button type="primary" onClick={onViewApproveDraft}>
                  Yes
                </Button>
              </CardFooterItem>
            </CardFooter>
          )}
        </Card>
      </div>
    )
  },
)
